import { Post } from "./Post/Post";
import { Dispatch, SetStateAction } from "react";
import styles from "./Feed.module.scss";
import { InstagramOptionsType } from "@/types/ModuleOptionsType";
import { Button } from "@/components/Button/Button";

interface FeedProps {
  props: {
    images: unknown[];
    // resize: Element | null | undefined;
    // follow: Element | null | undefined;
    loadMore: boolean;
    loadCount: number;
    loadMoreText: string;
    setImageCount: Dispatch<SetStateAction<number>>;
    followUrl?: string;
    followText: string;
    options: InstagramOptionsType;
  };
}

export const Feed = ({ props }: FeedProps) => {
  const {
    box: { show_border_radius, show_box_shadow, show_card_box },
    show_loadmore,
  } = props.options;

  const {
    setImageCount,
    loadMore,
    loadCount,
    followText,
    followUrl,
    loadMoreText,
  } = props;

  const buttonsJSX = (
    <div className="sbi_load">
      <div className="insta-buttons">
        <div className="load-more-container is-flex is-justify-content-center">
          {loadMore ? (
            <Button
              type="primary"
              href={""}
              target=""
              onClick={() => {
                setImageCount((state) => state + loadCount);
              }}
              className="mx-auto"
            >
              {loadMoreText}
            </Button>
          ) : followUrl ? (
            <Button
              type="primary"
              href={followUrl}
              target="_blank"
              className="mx-auto"
            >
              {followText}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );

  const imagesJSX = (
    <div id="sbi_images" className={styles["sbi-images"]}>
      {props.images.map((image, i) => (
        <Post
          key={i}
          image={image}
          show_border_radius={show_border_radius}
          show_box_shadow={show_box_shadow}
          show_card_box={show_card_box}
        />
      ))}
    </div>
  );
  return (
    <>
      {imagesJSX} {show_loadmore && buttonsJSX}
    </>
  );
};
